import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  carouselRoot: {
    display: 'flex',
    width: '100%',
    height: 'inherit',
    maxWidth: '550px',

    [theme.breakpoints.up(768)]: {
      width: '70%'
    }
  },
}));
